import React, { useEffect } from 'react'
import './styles.scss'
import CountUp from 'react-countup'

interface Props {
  count: number
}

export const Counter = ({ count }: Props) => {
  return (
    <div className='counter'>
      <CountUp end={count} duration={2} separator='&#8239;' />
      <div>
        <span className='suffix'>malade{count > 1 ? 's' : ''}</span>
      </div>
    </div>
  )
}
